<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_i"></a>THE RODERICK ALLEYN MYSTERIES VOLUME 4</h1>
<p class="author">NGAIO MARSH</p>
<div class="author">
<img alt="image" src="Common/logo.jpg"/><a id="page_ii"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?ab25e3d6